module.exports = __webpack_public_path__ + "static/financial_access5-33737659bec2c4d1259cff9aa91c321c.png";